import { ThemePack } from '@/types/theme-packs.types';
import { PayloadAction } from '@reduxjs/toolkit';
import { ProjectStateReducerCreator } from '../types';

const setWorkingProjectThemeReducer = (create: ProjectStateReducerCreator) => {
  return create.reducer((state, action: PayloadAction<ThemePack>) => {
    if (state.workingProject) {
      state.workingProject.settings.design.colors = {
        ...action.payload,
        updated_at: new Date().toISOString(),
      };
    }
  });
};

export default setWorkingProjectThemeReducer;
